const MSApplicationLogo70x70 = {
    name: 'msapplication-square70x70logo',
    content: 'https://pastatic.picsart.com/cms-pastatic/649ee788-d07b-4381-880d-4049b2ad9fd5.png',
};
const MSApplicationLogo150x150 = {
    name: 'msapplication-square150x150logo',
    content: 'https://pastatic.picsart.com/cms-pastatic/4fc73df6-f86b-4956-9ccd-49a0e52c43c7.png',
};
const MSApplicationLogo310x150 = {
    name: 'msapplication-wide310x150logo',
    content: 'https://pastatic.picsart.com/cms-pastatic/ed51ded3-8998-4883-9285-74724e22dc46.png',
};
const MSApplicationLogo310x310 = {
    name: 'msapplication-square310x310logo',
    content: 'https://pastatic.picsart.com/cms-pastatic/83b1e3ab-1932-4c97-af4b-609fc342010d.png',
};
const MSApplicationLogos = {
    x70: MSApplicationLogo70x70,
    x150: MSApplicationLogo150x150,
    x310x150: MSApplicationLogo310x150,
    x310: MSApplicationLogo310x310,
};

export { MSApplicationLogo150x150, MSApplicationLogo310x150, MSApplicationLogo310x310, MSApplicationLogo70x70, MSApplicationLogos };
